import { Activity, HeartPulse, Sparkles, ChevronDown } from "lucide-react";

function Chip({ icon, label, value, dotClass = "bg-risk-low" }: { icon: React.ReactNode; label: string; value: string; dotClass?: string }) {
  return (
    <div className="flex items-center gap-3 px-3 py-2">
      <span className={`status-dot ${dotClass}`} style={{ boxShadow: "0 0 12px currentColor" }} />
      <div className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground flex items-center gap-1.5">
          {icon}{label}
        </span>
        <span className="text-[12px] text-foreground/90">{value}</span>
      </div>
    </div>
  );
}

export function StatusChips() {
  return (
    <div className="hidden md:flex items-center gap-1 divide-x divide-border">
      <Chip icon={<Activity className="h-3 w-3" />} label="System Status" value="All systems operational" dotClass="bg-risk-low text-risk-low" />
      <div className="flex items-center gap-3 px-3 py-2">
        <div className="grid h-5 w-5 place-items-center rounded bg-surface-elevated text-[10px] font-semibold">A</div>
        <div className="flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground flex items-center gap-1.5">
            <Sparkles className="h-3 w-3" />LLM Provider
          </span>
          <span className="text-[12px] text-foreground/90 flex items-center gap-1">Anthropic (BYOK)<ChevronDown className="h-3 w-3 opacity-60" /></span>
        </div>
      </div>
      <Chip icon={<HeartPulse className="h-3 w-3" />} label="Health" value="All services healthy" dotClass="bg-risk-low text-risk-low" />
    </div>
  );
}